import { List, ListItem, Popover, styled } from '@mui/material';

export const StyledPopover = styled(Popover)(() => ({
  '& span': {
    fontSize: '15px',
  },
}));

export const StyledList = styled(List)(() => ({
  padding: 0,
}));

export const StyledListItem = styled(ListItem)<{ selected?: boolean }>(({ theme, selected }) => ({
  padding: '12px 16px',
  cursor: selected ? 'default' : 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .MuiListItemIcon-root': {
    minWidth: 28,
    marginRight: 4,
  },
}));

export const StyledListHeader = styled(ListItem)(({ theme }) => ({
  padding: '4px 16px',
  cursor: 'default',
  '> *': {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
}));
